module.exports = __webpack_public_path__ + "img/CardImageSurvey10.7f694556.png";